import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import InfiniteScrollTrigger from "./InfiniteScrollTrigger";
export default function CommonInfiniteScrollWrapper(t0) {
  const $ = _c(8);
  const {
    loading,
    onBottomIntersection,
    children
  } = t0;
  let t1;
  if ($[0] !== loading) {
    t1 = loading && <div className="tw-w-full tw-text-center tw-mt-8 tw-absolute tw-bottom-0"><CircleLoader size={CircleLoaderSize.MEDIUM} /></div>;
    $[0] = loading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onBottomIntersection) {
    t2 = <InfiniteScrollTrigger onIntersection={onBottomIntersection} />;
    $[2] = onBottomIntersection;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <div className="tw-overflow-hidden tw-relative">{children}{t1}{t2}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}